(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vl-newsletter-popup"]) return;
  try {
    
(() => {
  const storageKey = 'vellrive-welcome-popup-v1';
  const initialized = new WeakSet();
  function readState() {
    try { return JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch { return {}; }
  }
  function writeState(value) {
    try { localStorage.setItem(storageKey, JSON.stringify(value)); } catch {}
  }
  function initialize(root) {
    const dialogs = root.querySelectorAll('[data-vl-newsletter]');
    dialogs.forEach((dialog) => {
      if (initialized.has(dialog) || typeof dialog.showModal !== 'function') return;
      initialized.add(dialog);
      let timer;
      function open() {
        if (dialog.isConnected && !dialog.open && !document.querySelector('dialog[open]')) dialog.showModal();
      }
      dialog.querySelectorAll('[data-vl-newsletter-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('close', () => {
        clearTimeout(timer);
        const state = readState();
        if (!state.subscribed) writeState({ dismissedUntil: Date.now() + 7 * 86400000 });
      });
      if (dialog.querySelector('[data-vl-signup-success]')) {
        writeState({ subscribed: true });
        open();
        return;
      }
      if (dialog.querySelector('[data-vl-signup-errors]')) {
        open();
        return;
      }
      const state = readState();
      if (dialog.dataset.hideAuto === 'true' || state.subscribed || state.dismissedUntil > Date.now()) return;
      timer = setTimeout(() => {
        if (document.visibilityState === 'hidden') document.addEventListener('visibilitychange', () => { if (!document.hidden) open(); }, { once: true });
        else open();
      }, Number(dialog.dataset.delay) || 10000);
    });
  }
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-vl-newsletter-open]')) return;
    const dialog = document.querySelector('[data-vl-newsletter]');
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
